/**
 * @auth 赖传峰
 * @date 2025/2/20
 */
export const enum ReportType {
  PORN = 'porn', // 色情
  POLITICAL = 'political', // 政治
  VIOLENCE = 'violence', // 暴力
}

export const reportTypes: { value: ReportType, title: `report-${ReportType}` }[] = [
  {
    value: ReportType.PORN,
    title: 'report-porn',
  },
  {
    value: ReportType.POLITICAL,
    title: 'report-political',
  },
  {
    value: ReportType.VIOLENCE,
    title: 'report-violence',
  },
]

export const enum ReportTarget {
  SHARED = 'shared', // 整个分享
  FOLDER = 'folder', // 当前文件夹所有文件
  PARTIAL = 'partial', // 部分文件
}
